// IMPORT ALL IMAGES at the top of the file
import diamondImg from '../assets/image/diamond.jpeg';
import rubyImg from '../assets/image/ruby.jpeg';
import sapphireImg from '../assets/image/sapphire.jpeg';
import emeraldImg from '../assets/image/emerald.jpeg';
import amethystImg from '../assets/image/amethyst.jpeg';
import topazImg from '../assets/image/topaz.jpeg';
import pearlImg from '../assets/image/pearl.jpeg';
import opalImg from '../assets/image/opal.jpeg';
import garnetImg from '../assets/image/garnet.jpeg';
import citrineImg from '../assets/image/citrine.jpeg';

export const gemstoneDetails = [
  {
    id: 1,
    name: "Diamond",
    hardness: "10 (Mohs scale)",
    color: "Colorless / Fancy",
    birthstone: "April",
    description: "Diamonds are the hardest natural material on Earth, symbolizing enduring love and strength. Formed billions of years ago deep within the earth, each diamond is a unique marvel of nature. Their exceptional brilliance and fire have made them the ultimate symbol of commitment and luxury throughout history.",
    image: diamondImg  // ← Using imported image
  },
  {
    id: 2,
    name: "Ruby",
    hardness: "9 (Mohs scale)",
    color: "Red",
    birthstone: "July",
    description: "Rubies are the embodiment of passion and love. Their vibrant red hue has earned them the nickname 'the king of gemstones.' They are prized for their intense color and durability. Rubies have adorned crowns, jewelry, and armor throughout history and are associated with power, wealth, and protection. The finest rubies often display a fluorescent glow that makes them appear to burn from within.",
    image: rubyImg  // ← Using imported image
  },
  {
    id: 3,
    name: "Sapphire",
    hardness: "9 (Mohs scale)",
    color: "Blue / Fancy",
    birthstone: "September",
    description:"Sapphires are the gems of wisdom and royalty. While blue is the most well-known sapphire color, these gemstones can appear in various shades, from deep royal blue to light pastels. Ancient cultures believed that sapphires brought spiritual insight and protection. Today, they remain a symbol of elegance and class. The most prized sapphires come from historic highland and riverine deposits, known for their velvety blue hues and exceptional clarity.",
    image: sapphireImg  // ← Using imported image
  },
  {
    id: 4,
    name: "Emerald",
    hardness: "7.5-8 (Mohs scale)",
    color: "Green",
    birthstone: "May",
    description:"Emeralds are the green gems that evoke images of lush forests and vibrant life. Their rich color symbolizes renewal and growth. Cleopatra was famously fond of emeralds, and they have been associated with fertility, rebirth, and good fortune. However, their relative softness compared to other gemstones requires careful handling and maintenance.",
    image: emeraldImg  // ← Using imported image
  },
  {
    id: 5,
    name: "Amethyst",
    hardness: "7 (Mohs scale)",
    color: "Purple",
    birthstone: "February",
    description:"Amethyst, with its regal purple hue, is a gemstone associated with sobriety and clarity of mind. It's believed to have calming and meditative properties, making it a popular choice for jewelry worn during stressful times. The ancient Greeks believed amethyst could prevent intoxication, leading to the gem's name, which is derived from the Greek word ",
    image:amethystImg
  },
  {
    id: 6,
    name: "Topaz",
    hardness: "8 (Mohs scale)",
    color: "Golden / Blue",
    birthstone: "November",
    description:"Topaz is known for its impressive range of colors, from warm, sunny yellows to deep blues. Ancient Egyptians believed that topaz had protective powers, while the Greeks believed it made the wearer invisible. Today, it is cherished for its versatility and affordability",
    image: topazImg  // ← Using imported image
  },
  {
    id: 7,
    name: "Pearl",
    hardness: "2.5-4.5 (Mohs scale)",
    color: "White / Cream / Black",
    birthstone: "June",
    description:"Pearls are unique among gemstones as they are produced by living organisms, specifically mollusks like oysters and mussels. Their iridescent luster and timeless elegance have made them a symbol of purity and sophistication. Pearls have adorned royalty and continue to be a staple in classic jewelry pieces.",
    image: pearlImg  // ← Using imported image
  },
  {
    id: 8,
    name: "Opal",
    hardness: "5.5-6.5 (Mohs scale)",
    color: "Play of colors",
    birthstone: "October",
    description:"Opals are renowned for their mesmerizing play of colors, known as  They are often associated with creativity and inspiration due to their ever-changing and ethereal appearance. Opals are delicate gems that require special care to preserve their beauty, and they have been treasured for centuries for their unique and captivating allure.", 
    image: opalImg  // ← Using imported image
  },
  {
    id: 9,
    name: "Garnet",
    hardness: "6.5-7.5 (Mohs scale)",
    color: "Red / Green / Orange",
    birthstone: "January",
    description:"Garnets are the gems of love and commitment. They are often gifted to symbolize affection and trust between loved ones. While red is the most well-known color for garnets, they also come in shades of green, orange, and even rare blue. Their durability and affordability make them a popular choice for jewelry.",
    image: garnetImg  // ← Using imported image
  },
  {
    id: 10,
    name: "Citrine",
    hardness: "7 (Mohs scale)",
    color: "Yellow / Golden",
    birthstone: "November",
    description:"Citrine is a gemstone known for its warm and sunny appearance. Its name is derived from the French word  which means lemon, owing to its vibrant yellow color. Citrine is associated with positivity, energy, and abundance. It is often used as a healing stone and is believed to promote mental clarity and optimism.",
    image: citrineImg  // ← Using imported image
  }
];

// Keep your navigationData the same...
export const navigationData = {
  // ... your existing navigation data
  precious: [
    "Pigeon Blood Ruby",
    "Sunset Ruby",
    "Star Ruby",
    // ... rest of your precious gems
  ],
  fine: [
    "Aquamarine",
    "Alexandrite",
    { name: "Blue Zircon", tag: "HOT" },
    // ... rest of your fine gems
  ],
  tourmaline: [
    "Neon Tourmaline",
    "Blue Tourmaline",
    // ... rest of your tourmaline
  ],
  garnets: [
    "Demantoid Garnet",
    "Grossular Garnet",
    { name: "Rich Green Garnet", tag: "NEW" },
    // ... rest of your garnets
  ],
  viewAll: [
    "Gemstone Type",
    "Gems Online",
    { name: "New Arrivals", tag: "NEW" },
    { name: "Gems on Sale", tag: "SALE" },
    // ... rest of view all items
  ]
};

// Intro description for home page - appears before the gem list
export const homePageIntro = {
  title: "Explore Our Gemstone Collection",
  description: "Welcome to our exquisite collection of precious and fine gemstones. Each stone in our collection is carefully selected for its exceptional quality, color, and brilliance. From the fiery red of rubies to the mesmerizing green of emeralds, discover the perfect gemstone that speaks to your heart. All our gems come with certification and guaranteed authenticity."
};
